import { createFileRoute } from "@tanstack/react-router";
import { LifeBuoyIcon } from "lucide-react";
import { SupportView } from "@/components/support/support-view";

export const Route = createFileRoute("/_workspace/support")({
  component: SupportPage,
});

function SupportPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-3xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <LifeBuoyIcon className="size-3.5" />
            Help & support
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Support</h1>
          <p className="text-muted-foreground text-sm">
            Guidance for account issues, billing questions, and document generation.
          </p>
        </div>

        <SupportView />
      </div>
    </main>
  );
}
